import React from 'react';

export const IconSmallTrashLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M9.75 4h4.5L15 5h3v2H6V5h3l.75-1zM17 9H7l.917 10.09a1 1 0 00.996.91h6.174a1 1 0 00.996-.91L17 9z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
